import { useState, useEffect } from "react"
import { RESTAURANTS_API } from "./constants"

const useRestaurants = () => {
  const [json, setJson] = useState({})
  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    //console.log(data);
    const data = await fetch(RESTAURANTS_API).catch((err) => {
      console.error(err.message)
      // console.log(data);
    })
    // console.log(data);
    const jsonData = await data?.json().catch((err) => {
      console.log(err)
    })
    setJson(jsonData)
  }

  return json
}
export default useRestaurants
